import Vue from 'vue';
import Vuex from 'vuex';
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import createPersistedState from 'vuex-persistedstate';

import driverModule from './modules/driver';
import authModule from './modules/auth';
import fastQuoteModule from './modules/fastquote';
import toastr from './modules/toastr';
import bookingModule from '@/state/modules/booking';
import emailModule from '@/state/modules/email';
import adminModule from "@/state/modules/admin";

// Fuel levy
import fuelLevy from '@/state/modules/fuelLevy';

//setup firebaseConfig production
var firebaseConfig = {
  apiKey: "AIzaSyCNXy5cCQZdNEnSOOXecJb-ejMfpLOxRK0",
  authDomain: "wrapp-waste.firebaseapp.com",
  databaseURL: "https://wrapp-waste.firebaseio.com",
  projectId: "wrapp-waste",
  storageBucket: "wrapp-waste.appspot.com",
  messagingSenderId: "662553288814",
  appId: "1:662553288814:web:90dd222d1fe2d6766ac67f",
  measurementId: "G-KV0CXS3XRV"
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

Vue.use(Vuex);
const store = new Vuex.Store({
  plugins: [createPersistedState({
    paths: ['auth'],
    storage: window.sessionStorage
  })],
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    driver: driverModule,
    auth: authModule,
    fastQuote: fastQuoteModule,
    booking: bookingModule,
    email: emailModule,
    admin: adminModule,
    toastr,
    fuelLevy
  }
});
onAuthStateChanged(auth, (user) => {
  if(user){
    void store.dispatch('auth/completeLogin');
  }
});

export default store;